module.exports = __webpack_public_path__ + "img/ht_icon_history.924bf8b1.svg";